import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";

const HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFB9D1EA" },
};

const COLUMN_HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFD9D9D9" },
};

const THIN_BLACK = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const BODY_FONT = { name: "Calibri", size: 11 };

const COL_START = 4; // D
const COL_END = 7; // G
const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

function borderCell(cell) {
  cell.border = THIN_BLACK;
}

function setCell(ws, row, col, value, options = {}) {
  const cell = ws.getCell(row, col);
  cell.value = value;
  cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  borderCell(cell);
  cell.alignment = {
    horizontal: options.align || "center",
    vertical: "middle",
    wrapText: true,
  };
  if (options.fill) cell.fill = options.fill;
}

function formatTurnoverPct(value) {
  if (value === null || value === undefined || value === "") return "";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  return num.toFixed(2);
}

export function buildBusinessActivitiesSheet(workbook, sectionA) {
  const ws = workbook.addWorksheet("Details of business activities", {
    views: [{ showGridLines: true }],
  });

  const widths = { A: 2, B: 2, C: 2, D: 8, E: 22, F: 42, G: 18 };
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });

  addSheetBackLink(ws, PARENT_SHEETS.GENERAL_DISCLOSURES, { mergeEnd: COL_END });

  const activities = sectionA?.productServices?.businessActivities || [];

  ws.mergeCells(TITLE_ROW, COL_START, TITLE_ROW, COL_END);
  const tableTitle = ws.getCell(TITLE_ROW, COL_START);
  tableTitle.value =
    "Details of business activities (accounting for 90% of the turnover)";
  tableTitle.font = { ...BODY_FONT, bold: true };
  tableTitle.fill = HEADER_FILL;
  borderCell(tableTitle);
  tableTitle.alignment = { horizontal: "center", vertical: "middle", wrapText: true };

  const headers = [
    { col: COL_START, label: "Sr. No." },
    { col: 5, label: "Description of Main Activity" },
    { col: 6, label: "Description of Business Activity" },
    { col: COL_END, label: "% of Turnover of the entity" },
  ];

  headers.forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, { bold: true, fill: COLUMN_HEADER_FILL, align: "center" });
  });

  const rows = activities.length ? activities : [{}];

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_START, String(idx + 1), { align: "center" });
    setCell(ws, row, 5, item?.mainActivity ?? "", { align: "left" });
    setCell(ws, row, 6, item?.businessActivity ?? "", { align: "left" });
    setCell(ws, row, COL_END, formatTurnoverPct(item?.turnoverPercentage), {
      align: "right",
    });
  });

  return ws;
}
